import { doc, getDoc } from "firebase/firestore";
import { db } from "../firebase";
import ukConnectDataCsvUrl from "../pages/ukconnet data.csv";

let cachedAllowedNumbers = null;
let loadingAllowedNumbers = null;

export function normalizeUkConnectDataNumber(value) {
  const digits = String(value || "").replace(/\D/g, "");

  if (digits.startsWith("233") && digits.length === 12) {
    return digits.slice(3);
  }

  if (digits.startsWith("0") && digits.length === 10) {
    return digits.slice(1);
  }

  return digits;
}

function parseAllowedNumbers(csvText) {
  return new Set(
    String(csvText || "")
      .split(/\r?\n/)
      .map((line) => normalizeUkConnectDataNumber(line.split(",")[0]))
      .filter((number) => /^\d{9}$/.test(number))
  );
}

export async function loadUkConnectDataNumbers() {
  if (cachedAllowedNumbers) {
    return cachedAllowedNumbers;
  }

  if (!loadingAllowedNumbers) {
    loadingAllowedNumbers = fetch(ukConnectDataCsvUrl)
      .then((response) => {
        if (!response.ok) {
          throw new Error("Unable to load UK Connect data numbers.");
        }
        return response.text();
      })
      .then((csvText) => {
        cachedAllowedNumbers = parseAllowedNumbers(csvText);
        return cachedAllowedNumbers;
      })
      .finally(() => {
        loadingAllowedNumbers = null;
      });
  }

  return loadingAllowedNumbers;
}

async function isAcceptNewNumbersEnabled() {
  try {
    const settingsSnap = await getDoc(doc(db, "settings", "packages"));
    return settingsSnap.exists() ? settingsSnap.data().acceptNewNumbersEnabled === true : false;
  } catch {
    return false;
  }
}

export async function assertUkConnectDataNumber(value) {
  const normalizedNumber = normalizeUkConnectDataNumber(value);
  const acceptNewNumbersEnabled = await isAcceptNewNumbersEnabled();

  if (acceptNewNumbersEnabled) {
    return normalizedNumber;
  }

  const allowedNumbers = await loadUkConnectDataNumbers();

  if (!allowedNumbers.has(normalizedNumber)) {
    throw new Error("New numbers are not accepted now.");
  }

  return normalizedNumber;
}
